import config from "../../../../packages/config"
import { Link } from "../../../../packages/ui/link"

export const frontmatter = {
  title: "Licenses",
  date: "2026-04-03",
}

### Overview

{config.core.projectName} is an open-source project licensed under the MIT License. This page explains what you can and cannot do with the codebase.

### MIT License

{config.core.projectName} is licensed under the MIT License, one of the most permissive open source licenses available.

**You are free to:**

- Use the code for personal or commercial projects
- Modify the code to suit your needs
- Distribute copies of the original or modified code
- Sublicense the code to others
- Sell applications built with the code

**Requirements:**

- Include the original copyright notice and MIT License text in any copy of the software or substantial portions of it

**The MIT License does not:**

- Provide any warranty
- Hold the authors liable for any damages
- Require you to open source your own code

### Full MIT License Text

<pre className="whitespace-pre-wrap rounded-lg bg-muted/50 p-6 font-mono text-sm">
  {`MIT License

Copyright (c) 2024 ${config.core.projectName}

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}
</pre>

### What You Own

Applications you build using {config.core.projectName} belong entirely to you. You retain full ownership of:

- Your application code and business logic
- Any modifications or extensions you make
- Your user data and content
- Your brand and intellectual property

### Questions

If you have questions about licensing or need clarification on permitted uses, please contact us at <Link href={`mailto:${config.core.supportEmail}`}>{config.core.supportEmail}</Link>.
